const UPDATED_STORE = ['ediya'];
export default UPDATED_STORE;